import { throttle } from "lodash-es";
import { useCallback, useEffect, useRef } from "react";
function useThrottle(callback, wait) {
    const ref = useRef();
    useEffect(()=>{
        ref.current = callback;
    }, [
        callback
    ]);
    const throttledCallback = useCallback(throttle((...args)=>{
        ref.current?.(...args);
    }, wait), []);
    return throttledCallback;
}
export { useThrottle };

//# sourceMappingURL=use-throttle.js.map